import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ContactsRoundedIcon from "@material-ui/icons/ContactsRounded";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { NavLink } from "react-router-dom";
import { getPost } from "../actions/productActions";
import { connect } from "react-redux";
import { animated } from "react-spring";
import { Transition } from "react-spring/renderprops"
import ZoomOutMapRoundedIcon from '@material-ui/icons/ZoomOutMapRounded';
import {
    Grid,
    Box,
    Card,
    Modal,
    Fade,
    CardActionArea,
    TextField,
    Button,
    CircularProgress,
} from "@material-ui/core";
import AwesomeSlider from "react-awesome-slider";
import { addCart } from "../actions/cartAction";
import "react-awesome-slider/dist/styles.css";
import ImageGallery from "react-image-gallery";
import ShowMoreText from "react-show-more-text";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import "react-awesome-slider/dist/custom-animations/cube-animation.css";
import Backdrop from "@material-ui/core/Backdrop";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PhoneIcon from "@material-ui/icons/Phone";
import FavoriteIcon from "@material-ui/icons/Favorite";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import CheckIcon from "@material-ui/icons/Check";
import LoyaltyRoundedIcon from "@material-ui/icons/LoyaltyRounded";
import { addWishlist } from "../actions/wishlistActions";
import StarsIcon from "@material-ui/icons/Stars";
import "@open-wa/whatsapp-button/whatsapp-button.js";
import Menu from "./Menu"
import { toogleDrawer } from "../actions/authActions";
// import FavoriteIcon from '@material-ui/icons/Favorite';
import Share from "./sharepage";
import "./Styles.css";
// import { Passers } from "prop-passer";
import {
    EmailShareButton,
    FacebookShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PinterestIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    TumblrIcon,
    TwitterIcon,
    ViberIcon,
    VKIcon,
    WeiboIcon,
    WhatsappIcon,
    WorkplaceIcon
} from "react-share";
import styled from "@emotion/styled";
import { jsx } from "@emotion/core";



const drawerWidth = 240;


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    Paperroot: {
        flexGrow: 1,
        maxWidth: 700,
    },
    nav: {
        textDecoration: "none",
        color: "inherit",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {

    },

    menuButton: {
        marginRight: theme.spacing(2),

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    screen: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },

    container: {
        height: "400px",
        position: "relative",
        width: "100%",
        cursor: "pointer"
    },
    media: {
        height: "400px",
        // width: "100%",
        maxWidth: "400px",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        margin: "9px",
    },
}));
const TestScreen = styled("div")`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.bgColor};
`;
const Container = styled("div")`
  height: 400px;
  position: relative;
  width: 100%;
  cursor: pointer;
  & > div {
    will-change: transform, opacity;
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;
function About(props) {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const [open, setOpen] = React.useState(false);
    const [currentImage, setcurrentImage] = useState("");
    const handleOpen = (img) => {
        setOpen(true);
        setcurrentImage(img);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [post, setpost] = useState([]);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const [index, setindex] = useState(0)

    const toggle = () => {
        index === 2 ? setindex(0) : setindex(index + 1)
    }
    const images = [
        {
            original: `${props.products.post.image1}`,
            thumbnail: `${props.products.post.image1}`,
        },
        {
            original: `${props.products.post.image2}`,
            thumbnail: `${props.products.post.image2}`,
        },
        {
            original: `${props.products.post.image3}`,
            thumbnail: `${props.products.post.image3}`,
        },
    ];

    const mainprops = props;
    function TestScreen1(props) {
        return <TestScreen bgColor="inherit">
            {mainprops.products.post.image1 ? <img className={classes.media} src={`${mainprops.products.post.image1}`} /> : null}


        </TestScreen>;
    }

    function TestScreen2(props) {
        return <TestScreen bgColor="inherit">{mainprops.products.post.image2 ? <img className={classes.media} src={`${mainprops.products.post.image2}`} /> : <img className={classes.media} src={`${mainprops.products.post.image1}`} />}
        </TestScreen>;
    }

    function TestScreen3(props) {
        return <TestScreen bgColor="inherit">{mainprops.products.post.image3 ? <img className={classes.media} src={`${mainprops.products.post.image3}`} /> : <img className={classes.media} src={`${mainprops.products.post.image2}`} />}
        </TestScreen>;
    }

    const testScreens = [TestScreen1, TestScreen2, TestScreen3];


    useEffect(() => {
        props.getPost(props.match.params.id);
    }, []);
    const drawer = (
        <div>
            <div className={classes.toolbar} />
            <Divider />
            <List>
                <NavLink to="/" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <HomeRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Home"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/shop" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <StoreRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Shop"} />
                    </ListItem>
                </NavLink>

                {props.auth.isAuthenticated ? (
                    <>
                        <NavLink to="/cart" className={classes.nav}>
                            <ListItem button>
                                <ListItemIcon>
                                    <ShoppingCartRoundedIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Cart"} />
                            </ListItem>
                        </NavLink>
                        <NavLink to="/wishlist" className={classes.nav}>
                            <ListItem button>
                                <ListItemIcon>
                                    <StarsIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={"Wishlist"} />
                            </ListItem>
                        </NavLink>
                    </>
                ) : null}

                <NavLink to="/contact" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <ContactsRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Contact Us"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/about" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <InfoRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"About Us"} />
                    </ListItem>
                </NavLink>
            </List>
        </div>
    );

    const container =
        window !== undefined ? () => window.document.body : undefined;


    // const ShareList = Passers({
    //     url,
    //     className: "network__share-button",
    // })({
    //     className: "network cursor-pointer hover transition--default",
    //     title: `Share ${String(window.location)}`,
    // })("li");

    return (
        <div
        // className={classes.root}
        >
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={() => {
                            props.toogleDrawer()
                        }}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        align="center"
                        // noWrap
                        style={{
                            fontFamily: " 'Berkshire Swash', cursive",
                            // border: "1px solid",
                            width: "100%",
                        }}
                    >
                        {props.website.website.header}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Menu />
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <div></div>
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                    direction="row"
                    spacing={2}
                >
                    <Grid item xs={12} lg={6}>
                        <div>

                            <Container onClick={toggle}>
                                <Transition
                                    native
                                    reset
                                    unique
                                    items={index}
                                    from={{ opacity: 0, transform: "translate3d(100%, 0 ,0)" }}
                                    enter={{ opacity: 1, transform: "translate3d(0%, 0, 0)" }}
                                    leave={{ opacity: 0, transform: "translate3d(-50%, 0, 0)" }}
                                >
                                    {index => style => (
                                        <animated.div style={{ ...style }}>
                                            {React.createElement(testScreens[index])}
                                        </animated.div>
                                    )}
                                </Transition>
                            </Container>
                            <Grid container justify="center" alignItems="flex-end">
                                <Grid item>
                                    <IconButton aria-label="zoom" onClick={
                                        () =>
                                            handleOpen(
                                                index === 0 ? `${props.products.post.image1}` : index === 1 ? `${props.products.post.image2}` : `${props.products.post.image1}`

                                            )

                                    }>
                                        <ZoomOutMapRoundedIcon style={{ color: "#de115a" }} />
                                    </IconButton></Grid>
                            </Grid >

                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <>
                            {window.innerWidth > 700 ? (
                                // <Box
                                //     variant="outlined"
                                //     style={{
                                //         marginBottom: "2rem",
                                //         marginTop: "7rem",
                                //         // margin: "2rem"
                                //         padding: "4rem"
                                //     }}
                                // >
                                <CardActionArea>
                                    <Typography align="center" variant="h3">
                                        {props.products.post.pname}
                                    </Typography>

                                    <Typography
                                        color="primary"
                                        align="center"
                                        variant="h5"
                                    >
                                        ₹ {props.products.post.price}
                                    </Typography>
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Button
                                            style={{
                                                marginTop: "0.5rem",
                                                fontSize: "0.5rem",
                                                // margincenter: "auto",
                                                borderRadius: "2rem",
                                            }}
                                            variant="contained"
                                            color="primary"
                                            // className={classes.button}
                                            size="small"
                                            startIcon={<CheckIcon />}
                                        >
                                            {props.products.post.category}
                                        </Button>
                                    </Grid>
                                    <Typography align="center" variant="h5">
                                        {" "}
                                        {props.products.post.subcategory ? (
                                            <Button
                                                style={{
                                                    marginTop: "0.5rem",
                                                    fontSize: "0.5rem",
                                                    // marginLeft: "auto",
                                                    borderRadius: "2rem",
                                                }}
                                                variant="contained"
                                                color="primary"
                                                // className={classes.button}
                                                size="small"
                                                startIcon={
                                                    <LoyaltyRoundedIcon />
                                                }
                                            >
                                                {
                                                    props.products.post
                                                        .subcategory
                                                }
                                            </Button>
                                        ) : (
                                                ""
                                            )}
                                    </Typography>

                                    <Typography align="center">
                                        <ShowMoreText
                                            /* Default options */
                                            lines={8}
                                            more={"read more"}
                                            less="read less"
                                            anchorClass={classes.post}
                                            // onClick={executeOnClick}
                                            expanded={false}
                                            width={345.6}
                                        >
                                            <TextField
                                                style={{
                                                    marginTop: "0.3rem",
                                                    // fontSize: "2rem"
                                                }}
                                                disabled
                                                multiline
                                                fullWidth
                                                color="secondary"
                                                variant="outlined"
                                                value={props.products.post.text}
                                                name="text"
                                                rowsMax={10}
                                            ></TextField>
                                        </ShowMoreText>
                                    </Typography>
                                </CardActionArea>
                            ) : (
                                    // </Box>
                                    <Card
                                        variant="outlined"
                                        style={{
                                            marginBottom: "2rem",
                                            marginTop: "2rem",
                                            padding: "2rem",
                                        }}
                                    >
                                        <CardActionArea>
                                            <Typography align="left" variant="h3">
                                                {props.products.post.pname}
                                            </Typography>

                                            <Typography
                                                color="primary"
                                                align="left"
                                                variant="h5"
                                            >
                                                ₹ {props.products.post.price}
                                            </Typography>

                                            <Button
                                                style={{
                                                    marginTop: "0.5rem",
                                                    fontSize: "0.5rem",
                                                    // marginLeft: "auto",
                                                    borderRadius: "2rem",
                                                }}
                                                variant="contained"
                                                color="primary"
                                                // className={classes.button}
                                                size="small"
                                                startIcon={<CheckIcon />}
                                            >
                                                {props.products.post.category}
                                            </Button>
                                            <Typography align="left" variant="h5">
                                                {" "}
                                                {props.products.post.subcategory ? (
                                                    <Button
                                                        style={{
                                                            marginTop: "0.5rem",
                                                            fontSize: "0.5rem",
                                                            // marginLeft: "auto",
                                                            borderRadius: "2rem",
                                                        }}
                                                        variant="contained"
                                                        color="primary"
                                                        // className={classes.button}
                                                        size="small"
                                                        startIcon={
                                                            <LoyaltyRoundedIcon />
                                                        }
                                                    >
                                                        {
                                                            props.products.post
                                                                .subcategory
                                                        }
                                                    </Button>
                                                ) : (
                                                        ""
                                                    )}
                                            </Typography>
                                            <Typography
                                                align="left"
                                                style={{
                                                    marginTop: "2rem",
                                                    // fontSize: "2rem"
                                                }}
                                            >
                                                <ShowMoreText
                                                    /* Default options */
                                                    lines={8}
                                                    more={"read more"}
                                                    less="read less"
                                                    anchorClass={classes.post}
                                                    // onClick={executeOnClick}
                                                    expanded={false}
                                                    width={345.6}
                                                >
                                                    <TextField
                                                        disabled
                                                        multiline
                                                        fullWidth
                                                        color="secondary"
                                                        variant="outlined"
                                                        value={
                                                            props.products.post.text
                                                        }
                                                        name="text"
                                                        rowsMax={10}
                                                    ></TextField>
                                                </ShowMoreText>
                                            </Typography>
                                        </CardActionArea>
                                    </Card>
                                )}
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                style={{
                                    marginTop: "0.5rem",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                {props.auth.isAuthenticated ? (
                                    <Button
                                        onClick={() => {
                                            props.addCart(
                                                props.products.post._id
                                            );
                                            // console.log("lol");
                                        }}
                                        variant="outlined"
                                        // color="primary"
                                        style={{ backgroundColor: "#f1c75d" }}
                                        startIcon={<ShoppingCartRoundedIcon />}
                                    >
                                        Add to Cart
                                    </Button>
                                ) : null}
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                style={{
                                    marginTop: "0.5rem",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                {props.auth.isAuthenticated ? (
                                    <Button
                                        onClick={() => {
                                            props.addWishlist(
                                                props.products.post._id
                                            );
                                            // console.log("lol");
                                        }}
                                        disableElevation="true"
                                        // disabled="true"
                                        variant="contained"
                                        // color="primary"
                                        style={{ backgroundColor: "#fff" }}
                                        size="large"
                                        startIcon={<FavoriteIcon style={{ color: "#ed4956" }} />}
                                    >
                                    </Button>
                                ) : null}
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                style={{
                                    marginTop: "0.5rem",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                {/* <WhatsappShareButton title={props.products.post.pname}><WhatsappIcon size={38} round="true"></WhatsappIcon></WhatsappShareButton> */}
                                <Share />
                            </Grid>

                            <whatsapp-button phone="9271691704" dialcode="91" text="hello Home Town! I'm Intrested in buying your products." label="Start Chat"></whatsapp-button>

                        </>
                    </Grid>
                </Grid>
            </main>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <Grid container justify="center" alignItems="center">
                            <Grid item xs={10}>
                                <Typography
                                    style={{
                                        fontSize: "1.5rem",
                                        // color: "#c7c4c0",
                                        width: "230px",
                                        display: "block",
                                        // border: "1px solid brown",
                                        wordWrap: "break-word",
                                    }}
                                    variant="caption"
                                >
                                    {/* {props.products.post.pname} */}
                                    &nbsp;
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <IconButton onClick={handleClose}>
                                    <CloseRoundedIcon
                                        color="primary"
                                        fontSize="large"
                                    />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid container justify="center" alignItems="center">
                            <Grid item xs={12}>
                                <div
                                    className={classes.frameBorder}
                                    style={{ padding: "1rem" }}
                                >
                                    <Card
                                        style={{ height: "78vh" }}
                                        variant="outlined"
                                    >
                                        {/* {props.singleProfile.profile.avatar ? (
                                            <img
                                                src={`${imageuri}`}
                                                alt="Verified"
                                            />
                                        ) : null} */}
                                        {/* <img
                                            src="https://api.adorable.io/avatars/285/abott@adorable.png"
                                            alt="Verified"
                                        /> */}

                                        {/* <Img
                                            style={{ border: "1px solid" }}
                                            src={mimage}
                                        /> */}
                                        {}
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                backgroundImage: `url(${currentImage})`,
                                                backgroundSize: "contain",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition:
                                                    "center center",
                                            }}
                                        ></div>
                                    </Card>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}
const mapStateToProps = (state) => ({
    main: state.main,
    products: state.products,
    cart: state.cart,
    auth: state.auth,
    website: state.website,
});

export default connect(mapStateToProps, {
    getPost,
    addCart,
    addWishlist,
    toogleDrawer
})(About);
